import React from 'react';
import { CheckCircle2, Clock, Calendar, Video, BookOpen, Users, ArrowRight } from 'lucide-react';
import { DarkCard, LightCard, CheckListItem } from '../components/Cards';
export function ProgramulRise() {
  return <div className="bg-rise-white min-h-screen" data-id="element-913">
      {/* 1. Hero Section */}
      <section className="bg-rise-black text-rise-white py-12 md:py-20 px-6 relative overflow-hidden" data-id="element-914">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-915">
          <div className="absolute top-[-20%] right-[-10%] w-[50%] h-[100%] bg-rise-gold/5 blur-[120px] rounded-full" data-id="element-916"></div>
        </div>
        <div className="max-w-rise-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center relative z-10" data-id="element-917">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center order-1" data-id="element-918">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-919">
              PROGRAM DE 12 SĂPTĂMÂNI
            </div>
            <h1 className="font-playfair text-[36px] md:text-[52px] leading-tight mb-6" data-id="element-920">
              Programul R.I.S.E.
            </h1>

            {/* Photo on mobile only */}
            <div className="lg:hidden relative mb-8 w-full max-w-[280px] mx-auto" data-id="element-921">
              <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-3 translate-y-3 pointer-events-none" data-id="element-922"></div>
              <img src="https://cdn.magicpatterns.com/uploads/pG12JLChzvmkcCf8uS9D97/Teodora_1.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[4/5] object-cover rounded-xl shadow-lg relative z-10" data-id="element-923" />
            </div>

            <p className="font-dm-sans text-[19px] text-rise-white/80 max-w-xl mx-auto leading-relaxed mb-10" data-id="element-924">
              Realitate • Identitate • Stabilitate • Evoluție. Un parcurs
              transformator de 3 luni pentru a-ți reconstrui fundația interioară
              și a trăi o viață aliniată cu adevăratul tău potențial.
            </p>
            <div className="flex justify-center w-full" data-id="element-925">
              <a href="#inscriere" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors flex items-center justify-center gap-2 w-full max-w-md" data-id="element-926">
                Vreau să mă înscriu <ArrowRight size={18} data-id="element-927" />
              </a>
            </div>
          </div>

          {/* Photo on desktop only */}
          <div className="relative hidden lg:block w-full max-w-md mx-auto lg:ml-auto order-2" data-id="element-928">
            <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-5 translate-y-5 pointer-events-none" data-id="element-929"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pG12JLChzvmkcCf8uS9D97/Teodora_1.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[4/5] object-cover rounded-xl shadow-lg relative z-10" data-id="element-930" />
          </div>
        </div>
      </section>

      {/* 2. Pentru cine este */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-931">
        <div className="max-w-rise-content mx-auto" data-id="element-932">
          <div className="text-center mb-16" data-id="element-933">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-934">
              Acest program este pentru tine dacă:
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-935">
            <LightCard title="Te simți blocat" data-id="element-936">
              <ul className="space-y-4" data-id="element-937">
                <CheckListItem data-id="element-938">
                  Simți că trăiești pe pilot automat și zilele trec fără sens.
                </CheckListItem>
                <CheckListItem data-id="element-939">
                  Ai atins obiective externe (carieră, relații), dar interior
                  simți un gol.
                </CheckListItem>
                <CheckListItem data-id="element-940">
                  Te confrunți cu anxietate, stres cronic sau burnout.
                </CheckListItem>
                <CheckListItem data-id="element-941">
                  Îți este greu să iei decizii sau să pui limite sănătoase.
                </CheckListItem>
              </ul>
            </LightCard>
            <LightCard title="Îți dorești o schimbare" data-id="element-942">
              <ul className="space-y-4" data-id="element-943">
                <CheckListItem data-id="element-944">
                  Vrei să te cunoști mai bine și să îți înțelegi tiparele.
                </CheckListItem>
                <CheckListItem data-id="element-945">
                  Ești pregătit să îți asumi responsabilitatea pentru viața ta.
                </CheckListItem>
                <CheckListItem data-id="element-946">
                  Cauți instrumente practice pentru gestionarea emoțiilor.
                </CheckListItem>
                <CheckListItem data-id="element-947">
                  Îți dorești relații mai autentice și o viață cu sens.
                </CheckListItem>
              </ul>
            </LightCard>
          </div>
        </div>
      </section>

      {/* 3. Ce vei obține */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-948">
        <div className="max-w-rise-content mx-auto" data-id="element-949">
          <div className="text-center mb-16" data-id="element-950">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-951">
              BENEFICII
            </div>
            <h2 className="font-playfair text-[32px] md:text-[42px] mb-4" data-id="element-952">
              Ce vei obține în urma programului
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-953">
            <DarkCard title="Claritate Mentală" icon={<CheckCircle2 size={32} data-id="element-955" />} data-id="element-954">
              Vei învăța să îți liniștești mintea, să reduci zgomotul mental și
              să iei decizii din spațiul tău de putere interioară, nu din frică.
            </DarkCard>
            <DarkCard title="Stabilitate Emoțională" icon={<CheckCircle2 size={32} data-id="element-957" />} data-id="element-956">
              Vei dobândi instrumente pentru a naviga emoțiile dificile fără a
              te lăsa copleșit de ele, construind o reziliență emoțională
              solidă.
            </DarkCard>
            <DarkCard title="Aliniere Autentică" icon={<CheckCircle2 size={32} data-id="element-959" />} data-id="element-958">
              Vei descoperi cine ești cu adevărat dincolo de condiționări și vei
              începe să trăiești în aliniere cu valorile și dorințele tale
              profunde.
            </DarkCard>
          </div>
        </div>
      </section>

      {/* 4. Structura */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-960">
        <div className="max-w-rise-content mx-auto" data-id="element-961">
          <div className="text-center mb-16" data-id="element-962">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-963">
              Structura Programului (12 Săptămâni)
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-gray max-w-2xl mx-auto" data-id="element-964">
              Un parcurs pas cu pas, împărțit în 4 etape esențiale.
            </p>
          </div>

          <div className="space-y-8" data-id="element-965">
            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-966">
              <div className="md:w-1/4 shrink-0" data-id="element-967">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-968">
                  Modulul 1
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-969">
                  Săptămânile 1-3
                </div>
              </div>
              <div data-id="element-970">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-971">
                  Realitate: Acceptarea prezentului
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-972">
                  Începem prin a face un audit onest al vieții tale actuale.
                  Învățăm să privim realitatea fără filtre, să identificăm
                  mecanismele de apărare și să ieșim din starea de negare sau
                  victimizare.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-973">
              <div className="md:w-1/4 shrink-0" data-id="element-974">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-975">
                  Modulul 2
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-976">
                  Săptămânile 4-6
                </div>
              </div>
              <div data-id="element-977">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-978">
                  Identitate: Cine ești tu, de fapt?
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-979">
                  Explorăm credințele limitative, tiparele moștenite și rănile
                  emoționale. Separăm vocea autentică de vocile celorlalți și
                  reconstruim o imagine de sine sănătoasă și puternică.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-980">
              <div className="md:w-1/4 shrink-0" data-id="element-981">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-982">
                  Modulul 3
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-983">
                  Săptămânile 7-9
                </div>
              </div>
              <div data-id="element-984">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-985">
                  Stabilitate: Crearea ancorelor interioare
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-986">
                  Construim practici zilnice pentru reglarea sistemului nervos.
                  Învățăm să setăm limite sănătoase, să gestionăm stresul și să
                  ne creăm un spațiu interior de siguranță la care să ne putem
                  întoarce oricând.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-987">
              <div className="md:w-1/4 shrink-0" data-id="element-988">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-989">
                  Modulul 4
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-990">
                  Săptămânile 10-12
                </div>
              </div>
              <div data-id="element-991">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-992">
                  Evoluție: Integrare și acțiune aliniată
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-993">
                  Trecem de la teorie la practică. Definim o viziune clară
                  pentru viitor și creăm un plan de acțiune sustenabil, bazat pe
                  noua ta fundație interioară.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Ce include */}
      <section className="py-12 md:py-20 px-6 bg-rise-black text-rise-white" data-id="element-994">
        <div className="max-w-rise-content mx-auto" data-id="element-995">
          <div className="text-center mb-16" data-id="element-996">
            <h2 className="font-playfair text-[32px] md:text-[42px] mb-4" data-id="element-997">
              Ce este inclus în program
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-998">
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-999">
              <Video className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1000" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1001">
                12 Module Video
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1002">
                Lecții înregistrate pe care le poți parcurge în ritmul tău.
              </p>
            </div>
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-1003">
              <BookOpen className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1004" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1005">Caiet de Lucru</h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1006">
                Exerciții practice, jurnale și teme de reflecție pentru fiecare
                modul.
              </p>
            </div>
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-1007">
              <Users className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1008" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1009">
                6 Sesiuni Live Q&A
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1010">
                Întâlniri de grup bilunare pentru suport și clarificări.
              </p>
            </div>
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-1011">
              <Clock className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1012" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1013">Acces pe Viață</h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1014">
                Păstrezi accesul la toate materialele și actualizările viitoare.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Testimoniale (Short) */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-1015">
        <div className="max-w-rise-content mx-auto" data-id="element-1016">
          <div className="text-center mb-16" data-id="element-1017">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-1018">
              Experiențele participanților
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1019">
            <LightCard title="O transformare reală" data-id="element-1020">
              <p className="italic mb-4" data-id="element-1021">
                "Acest program mi-a schimbat complet perspectiva asupra vieții.
                Am învățat să mă ascult, să pun limite și să nu mă mai simt
                vinovată pentru că îmi doresc mai mult de la viață. Structura
                este excelentă!"
              </p>
              <div className="font-semibold text-rise-black" data-id="element-1022">Maria D.</div>
            </LightCard>
            <LightCard title="Am regăsit liniștea" data-id="element-1023">
              <p className="italic mb-4" data-id="element-1024">
                "După ani de terapie, simțeam că înțeleg mental problemele, dar
                nu știam cum să le rezolv practic. Programul R.I.S.E. mi-a
                oferit exact instrumentele de care aveam nevoie pentru a face
                schimbarea."
              </p>
              <div className="font-semibold text-rise-black" data-id="element-1025">Elena S.</div>
            </LightCard>
          </div>
        </div>
      </section>

      {/* 7. Investitie */}
      <section id="inscriere" className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-1026">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1027">
          <h2 className="font-playfair text-[32px] md:text-[42px] mb-6" data-id="element-1028">
            Investiția în evoluția ta
          </h2>
          <div className="bg-rise-black border border-rise-gold/40 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-1029">
            <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold" data-id="element-1030"></div>
            <div className="flex flex-col items-center gap-2 mb-2" data-id="element-1031">
              <div className="flex items-baseline justify-center gap-3 flex-wrap" data-id="element-1032">
                <span className="text-[24px] md:text-[28px] text-rise-white/50 line-through font-playfair" data-id="element-1033">
                  1.200 lei
                </span>
                <span className="text-[44px] md:text-[52px] font-playfair text-rise-gold leading-none" data-id="element-1034">
                  699 lei
                </span>
              </div>
              <p className="inline-block bg-rise-gold/15 text-rise-gold border border-rise-gold/40 rounded-full px-4 py-1 mt-2 font-dm-sans text-[12px] font-bold uppercase tracking-wider" data-id="element-1035">
                Preț special
              </p>
            </div>
            <p className="font-dm-sans text-[16px] text-rise-white/70 mb-8 mt-4" data-id="element-1036">
              Plată unică sau în 2 rate egale
            </p>
            <ul className="text-left space-y-4 mb-8 max-w-md mx-auto" data-id="element-1037">
              <CheckListItem data-id="element-1038">
                Acces complet la cele 12 module video
              </CheckListItem>
              <CheckListItem data-id="element-1039">Caiet de lucru digital (PDF)</CheckListItem>
              <CheckListItem data-id="element-1040">Acces la cele 6 sesiuni live de Q&A</CheckListItem>
              <CheckListItem data-id="element-1041">Grup privat de suport pe WhatsApp</CheckListItem>
              <CheckListItem data-id="element-1042">Acces pe viață la materiale</CheckListItem>
            </ul>

            <div className="flex justify-center" data-id="element-1043">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-block w-full md:w-auto" data-id="element-1044">
                Înscrie-te Acum
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 8. Final CTA (Light) */}
      <section className="py-14 md:py-24 px-6 bg-rise-white text-center relative overflow-hidden" data-id="element-1045">
        <div className="absolute inset-0 opacity-30 pointer-events-none flex items-center justify-center" data-id="element-1046">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold/40 rounded-full absolute" data-id="element-1047"></div>
          <div className="w-[600px] h-[600px] border-[1px] border-rise-gold/40 rounded-full absolute" data-id="element-1048"></div>
          <div className="w-[400px] h-[400px] border-[1px] border-rise-gold/40 rounded-full absolute" data-id="element-1049"></div>
        </div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-1050">
          <h2 className="font-playfair text-[32px] md:text-[48px] text-rise-black mb-6" data-id="element-1051">
            Ești pregătit să începi transformarea?
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-gray mb-10" data-id="element-1052">
            Nu mai amâna momentul în care alegi să trăiești o viață aliniată cu
            adevăratul tău potențial.
          </p>
          <div className="flex justify-center" data-id="element-1053">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors" data-id="element-1054">
              Vreau să mă înscriu
            </a>
          </div>
        </div>
      </section>
    </div>;
}